module.exports = __webpack_public_path__ + "static/media/Logo.c95b46ed.svg";